import { jsx as _jsx } from "react/jsx-runtime";
const ArrowTopRight = () => (_jsx("svg", Object.assign({ viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M13 11.78H12V4.71L2.03999 14.67L1.32999 13.96L11.29 4H4.21999V3H13V11.78Z" }) })));
ArrowTopRight.iconName = "arrow_top_right";
ArrowTopRight.iconCategory = "Arrows";
export default ArrowTopRight;
